import axios from 'axios';
import {
  AI_PROMPT_BUILDER_ADD_ROLES_AND_USERS_BEGIN,
  AI_PROMPT_BUILDER_ADD_ROLES_AND_USERS_SUCCESS,
  AI_PROMPT_BUILDER_ADD_ROLES_AND_USERS_FAILURE,
  AI_PROMPT_BUILDER_ADD_ROLES_AND_USERS_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { toast } from 'react-toastify';

export function addRolesAndUsers(args = {}) {
  return (dispatch) => {
    dispatch({
      type: AI_PROMPT_BUILDER_ADD_ROLES_AND_USERS_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/on-boarding/${projectId}/ai-roles-users`,
        args.values,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: AI_PROMPT_BUILDER_ADD_ROLES_AND_USERS_SUCCESS,
            data: res,
          });
          resolve(res);
          toast.success('Roles & Users Created Successfully!');
        },
        (err) => {
          dispatch({
            type: AI_PROMPT_BUILDER_ADD_ROLES_AND_USERS_FAILURE,
            data: { error: err },
          });
          reject(err);
          toast.error('Failed to create Roles & Users. Please try again.');
        },
      );
    });

    return promise;
  };
}

export function dismissAddRolesAndUsersError() {
  return {
    type: AI_PROMPT_BUILDER_ADD_ROLES_AND_USERS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case AI_PROMPT_BUILDER_ADD_ROLES_AND_USERS_BEGIN:
      return {
        ...state,
        addRolesAndUsersPending: true,
        addRolesAndUsersError: null,
      };

    case AI_PROMPT_BUILDER_ADD_ROLES_AND_USERS_SUCCESS:
      return {
        ...state,
        addRolesAndUsersPending: false,
        addRolesAndUsersError: null,
      };

    case AI_PROMPT_BUILDER_ADD_ROLES_AND_USERS_FAILURE:
      return {
        ...state,
        addRolesAndUsersPending: false,
        addRolesAndUsersError: action.data.error,
      };

    case AI_PROMPT_BUILDER_ADD_ROLES_AND_USERS_DISMISS_ERROR:
      return {
        ...state,
        addRolesAndUsersError: null,
      };

    default:
      return state;
  }
}
